import { render } from "./subjectdetail.vue?vue&type=template&id=ef61092a&scoped=true&ts=true"
import script from "./subjectdetail.vue?vue&type=script&lang=ts"
export * from "./subjectdetail.vue?vue&type=script&lang=ts"

import "./subjectdetail.vue?vue&type=style&index=0&id=ef61092a&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef61092a"]])

export default __exports__